import React from 'react'

import { useLayoutStyles } from '../../styles'
import NavBar from '../shared/Navbar'
import SEO from '../shared/Seo'

function Layout({ children, minimalNavbar, title, marginTop = 60 }) {
  const classes = useLayoutStyles()

  return (
    <section className={classes.section}>
      <SEO title={title} />
      <NavBar minimalNavbar={minimalNavbar} />
      <main style={{ marginTop }} className={classes.main}>
        <section className={classes.childrenWrapper}>
          <div className={classes.children}>{children}</div>
        </section>
      </main>
    </section>
  )
}

export default Layout
